import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function StickyBottomCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling 300px
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 lg:hidden transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="bg-white border-t-2 border-amber-500 shadow-2xl px-4 py-3">
        <div className="flex items-center gap-3">
          <Link
            to="/signup"
            className="flex-1 bg-amber-500 hover:bg-amber-600 text-black font-bold text-base px-6 py-4 rounded-lg transition-all duration-300 shadow-lg whitespace-nowrap touch-manipulation min-h-[56px] flex items-center justify-center"
          >
            <i className="ri-rocket-line mr-2 text-xl"></i>
            Start Free Trial
          </Link>
          <Link
            to="/demo"
            className="bg-gray-100 hover:bg-gray-200 text-gray-900 font-semibold px-5 py-4 rounded-lg transition-all duration-300 whitespace-nowrap touch-manipulation min-h-[56px] flex items-center justify-center"
          >
            <i className="ri-play-circle-line text-xl"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}